export const diaryKeys = {
	all: ["diaries"] as const,
	list: (filters: Record<string, unknown> = {}) =>
		[...diaryKeys.all, "list", filters] as const,
	detail: (id: string) => [...diaryKeys.all, "detail", id] as const,
	byPatient: (patientId: string) =>
		[...diaryKeys.all, "byPatient", patientId] as const,
	bySettings: (settings: Record<string, unknown> = {}) =>
		[...diaryKeys.all, "bySettings", settings] as const,
	tabs: (filters: Record<string, unknown> = {}) =>
		[...diaryKeys.all, "tabs", filters] as const,
	count: (filters: Record<string, unknown> = {}) =>
		[...diaryKeys.all, "count", filters] as const,
} as const;

// Helper function to create a diary query key
export const createGetDiaryKey = (diaryId?: string) => {
	if (diaryId) {
		return diaryKeys.detail(diaryId);
	}
	return diaryKeys.list();
};
